import { memo } from 'react';

declare global {
  // eslint-disable-next-line no-var
  var WallsioWidgets: {
    'wallsio-widget': { destructor: () => void; iframe: HTMLIFrameElement };
  };
}

export interface WallsioViewProps {
  wallsioCode: string;
}

/**
 * WallsioView component displays a Walls.io widget in an iframe.
 * @param wallsioCode - The code of the Walls.io widget to display.
 * @returns A React component that renders an iframe with the Walls.io widget.
 * @see https://walls.io/
 *
 * example code: 'j4z3r'
 * @example
 * <WallsioView wallsioCode="j4z3r" />
 */
export const WallsioView = memo(function WallsioView({
  wallsioCode,
  ...props
}: WallsioViewProps & React.ComponentPropsWithoutRef<'iframe'>) {
  return (
    <iframe
      title={'Walls.io'}
      allowFullScreen
      id="wallsio-iframe"
      src={`//my.walls.io/${wallsioCode}?nobackground=1&amp;show_header=0`}
      style={{
        border: 0,
        height: '800px',
        width: '100%',
      }}
      loading="lazy"
      {...props}
    />
  );
});

export default WallsioView;
